import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronGroup3FilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M0 3c0 .986.004 1.614.082 2.19A9.2 9.2 0 0 0 4.718 12a9.2 9.2 0 0 0-4.636 6.81C.004 19.388 0 20.015 0 21h2.4c0-1.021.007-1.474.06-1.87a6.8 6.8 0 0 1 4.019-5.327c.359-.157.781-.285 1.721-.555v-2.496c-.94-.27-1.362-.398-1.721-.555A6.8 6.8 0 0 1 2.46 4.87C2.407 4.474 2.4 4.021 2.4 3z"
                fill="currentColor"
            />
            <path
                d="M7.9 3c0 .986.004 1.614.082 2.19A9.2 9.2 0 0 0 12.618 12a9.2 9.2 0 0 0-4.636 6.81c-.078.577-.082 1.204-.082 2.19h2.4c0-1.021.007-1.474.06-1.87a6.8 6.8 0 0 1 4.019-5.327c.359-.157.782-.285 1.721-.555v-2.496c-.94-.27-1.362-.398-1.721-.555A6.8 6.8 0 0 1 10.36 4.87c-.053-.396-.06-.849-.06-1.87z"
                fill="currentColor"
            />
            <path
                d="M15.882 5.19C15.805 4.613 15.8 3.985 15.8 3h2.4c0 1.021.007 1.474.06 1.87a6.8 6.8 0 0 0 4.019 5.327c.359.157.781.285 1.721.555v2.496c-.94.27-1.362.398-1.721.555a6.8 6.8 0 0 0-4.019 5.327c-.053.396-.06.849-.06 1.87h-2.4c0-.986.005-1.613.082-2.19A9.2 9.2 0 0 1 20.518 12a9.2 9.2 0 0 1-4.636-6.81"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronGroup3FilledSize24Glyph.displayName = 'ChevronGroup3FilledSize24Glyph';
